import { render, staticRenderFns } from "./bon.vue?vue&type=template&id=6f42e3a4"
import script from "./bon.vue?vue&type=script&lang=js"
export * from "./bon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports